<template>
  <div class="content">
    <div v-if="show">
      <van-tabs v-model="tabActive" title-active-color="#F34740" inactive-color="#333" line-width="30" sticky>
          <van-tab v-for="(items,i) of tabList" :key="i" :title="items.tabName">
              <order-item :type="items.type"></order-item>
          </van-tab>
      </van-tabs>
    </div>
    <div v-else>
      <order-item uid="3"></order-item>
    </div>
    
  </div>
</template>

<script>
import orderItem from "@/components/orderItem"
import {mapState} from "vuex"
export default {
    data() {
        return {
            tabActive:"0",
            tabList:[{type:'',tabName:"全部订单"},{type:'10',tabName:"待支付"},{type:'51',tabName:"已关闭"},{type:"20",tabName:"支付成功"}],
        };
    },
    beforeCreate(){
        //  this.tabActive=this.$route.params.id;
    },
    created(){
        document.title=this.userInfo.user_type==2 ? "我的订单" : "保险订单";
        this.tabActive=Number(this.$route.params.id) ;
    },
    methods:{
       
    },
    computed:{
        ...mapState(["userInfo"]),
        show(){
          if(this.userInfo.user_type==1){
            return false;
          }else{
            return true;
          }
        }
    },
    components:{
        orderItem
    },
}
</script>

<style scoped>
  .content /deep/ .van-tabs__line{
    bottom: 0.5rem;
    height: 3px;
    background: linear-gradient(-270deg,rgba(243,71,64,1),rgba(254,142,137,1));
    border-radius:3px;
  }
    .content /deep/ .van-tab{
        font-size: 14px;
        color: #333;
    }
    .content /deep/ .van-tabs__nav{
        background: #f5f5f5;
        
    }
     /* .center /deep/ .van-tabs__line{
        bottom: 0.5rem;
        background: linear-gradient(left,#F34740,#FE8E89); 
    } */
</style>


// WEBPACK FOOTER //
// src/views/commonPage/myOrder.vue